import React, {Component} from 'react';
import {Col, Dropdown, Icon, Menu, message, Modal, Row} from 'antd';
import {connect} from 'react-redux';

import {queryUpdatePwd} from '@api/core/user';
import localDb from '@util/localDb';
import {cleanUser} from '@store/modules/user';
import UpdatePassword from '../home/UpdatePassword';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codeModalVisible: false,
      popVisible: false,
    };
  }

  componentDidMount() {}

  showCodeModal = () => {
    this.setState({ popVisible: false, codeModalVisible: true });
  };

  hideCodeModal = () => {
    this.setState({ codeModalVisible: false });
  };

  handleVisibleChange = visible => {
    this.setState({ popVisible: visible });
  };

  logout = () => {
    const { dispatch, router } = this.props;
    dispatch(cleanUser());
    localDb.clear();
    message.info('您已退出系统！');
    router.push('/login');
  };

  edit = user => {
    const context = this;
    const { dispatch, router } = this.props;
    queryUpdatePwd(user).then(res => {
      if (res.statusCode === 200) {
        context.hideCodeModal();
        message.success('密码修改成功,请重新登录！');
        dispatch(cleanUser());
        localDb.clear();
        router.push('/login');
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { user } = this.props;
    const menu = (
      <Menu>
        <Menu.Item>
          <a style={{ color: '#108ee9' }} onClick={this.showCodeModal}>
            修改密码
          </a>
        </Menu.Item>
      </Menu>
    );
    const { popVisible, codeModalVisible } = this.state;
    return (
      <div className="header">
        <Row type="flex" justify="end" align="middle">
          <Col className="user" span={8} offset={10}>
            <div className="header-line">
              <Dropdown
                overlay={menu}
                visible={popVisible}
                onVisibleChange={this.handleVisibleChange}
              >
                <div className="info">
                  {user.userName || '匿名'} <Icon type="down" style={{ fontSize: '15px' }} />
                </div>
              </Dropdown>
              <div className="exit" onClick={this.logout}>
                <Icon type="poweroff" style={{ fontSize: '15px' }} />
              </div>
            </div>
          </Col>
        </Row>
        {codeModalVisible ? (
          <Modal
            title="修改密码"
            visible={codeModalVisible}
            footer={false}
            onCancel={this.hideCodeModal}
            maskClosable={false}
            width={300}
          >
            <UpdatePassword
              user={user}
              title="修改密码"
              handSubmit={userDate => this.edit(userDate)}
            />
          </Modal>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(state => ({ user: state.user }))(Header);



// WEBPACK FOOTER //
// ./src/components/comm/Header.js